export default __webpack_public_path__ + "b925dbac2f0e5de91e52605d9adad1cc.png";